const mapReturnInstructionOption = instruction => ({
  id: instruction.id,
  name: instruction.name,
  type: instruction.type,
  steps: instruction.steps,
})

export const transformResponseGetReturnInstructionSets = response => {
  return response.results.map(mapReturnInstructionOption)
}
